import React from 'react';
import { SnackbarProvider as NotistackProvider } from 'notistack';
import SnackbarSuccess from './SnackbarSuccess';
import SnackbarError from './SnackbarError';

const SnackbarProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <NotistackProvider
      maxSnack={3}
      autoHideDuration={3000}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      Components={{
        success: SnackbarSuccess,
        error: SnackbarError,
      }}
    >
      {children}
    </NotistackProvider>
  );
};

export default SnackbarProvider;
